import React, { useState } from 'react';
import { PeriodChips } from '../../../components/NewPeriodChips';
import { ETFPriceChart } from './ETFPriceChart';
import { CHART_PERIOD_LEVELS } from '@/src/common/enum';

export const ETFChartDetails = () => {
  const [periodLevel, setPeriodLevel] = useState<string>(
    CHART_PERIOD_LEVELS.ONEYEAR,
  );

  const handlePeriodSelect = (period: string) => {
    setPeriodLevel(period);
  };

  return (
    <div>
      <ETFPriceChart periodLevel={periodLevel} />
      <PeriodChips
        periodData={Object.values(CHART_PERIOD_LEVELS) as CHART_PERIOD_LEVELS[]}
        activePeriod={4}
        onPeriodSelect={handlePeriodSelect}
      />
    </div>
  );
};
